import { useState, useEffect } from 'react';
import { collection, query, where, getDocs } from 'firebase/firestore';
import { onAuthStateChanged } from 'firebase/auth';
import { db, auth } from '../firebase';

export const useStudioAuth = (studioName) => {
  const [user, setUser] = useState(null);
  const [claimStatus, setClaimStatus] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, async (currentUser) => {
      setUser(currentUser);
      
      if (currentUser && studioName) {
        try {
          // Check if user has any claims for this studio
          const claimsRef = collection(db, 'studioProfileClaims');
          const q = query(
            claimsRef,
            where('studioName', '==', studioName),
            where('claimerEmail', '==', currentUser.email)
          );
          
          const snapshot = await getDocs(q);
          
          if (!snapshot.empty) {
            // Get the most recent claim
            const claims = snapshot.docs.map(doc => ({
              id: doc.id,
              ...doc.data()
            }));
            
            // Sort by submission date (most recent first)
            claims.sort((a, b) => b.submittedAt?.seconds - a.submittedAt?.seconds);
            const mostRecentClaim = claims[0];
            
            setClaimStatus(mostRecentClaim.status);
          } else {
            setClaimStatus(null);
          }
        } catch (error) {
          console.error('Error checking studio claim status:', error);
          setClaimStatus(null);
        }
      } else {
        setClaimStatus(null);
      }
      
      setLoading(false);
    });

    return () => unsubscribe();
  }, [studioName]);

  return { user, claimStatus, loading };
};
